import React, { useEffect, useRef, useState } from "react";
import { googleConfig } from "../services/api";

/**
 * 🔑 "CONTINUAR COM O GOOGLE" (29/09/2026 — sugestão do Everton, pedido do Nelson).
 *
 * Usa o botão oficial do Google (Google Identity Services): ele devolve um ID token, que o servidor confere
 * no próprio Google antes de entrar ou criar a conta (ver AuthEndpoints /api/auth/google).
 *
 * O Client ID vem do servidor (/api/auth/google/config). Sem ele configurado, o botão simplesmente não
 * aparece — a tela continua com e-mail e senha, como antes.
 */
let scriptPromise = null;
function carregarScript() {
  if (window.google?.accounts?.id) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://accounts.google.com/gsi/client";
      s.async = true; s.defer = true;
      s.onload = () => resolve();
      s.onerror = () => { scriptPromise = null; reject(new Error("script do Google não carregou")); };
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
}

export default function BotaoGoogle({ onCredencial, texto = "continue_with" }) {
  const alvo = useRef(null);
  const [clientId, setClientId] = useState(undefined); // undefined = carregando, null = desligado
  const cb = useRef(onCredencial);
  cb.current = onCredencial;

  // ✅ LIBERADO A TODOS em 29/09/2026, depois do teste do Nelson (conta nasceu verificada, cadastro no monitor).
  const liberado = true;
  useEffect(() => {
    if (!liberado) { setClientId(null); return; }
    googleConfig().then((r) => setClientId(r?.clientId || null)).catch(() => setClientId(null));
  }, [liberado]);

  useEffect(() => {
    if (!clientId || !alvo.current) return;
    let vivo = true;
    carregarScript().then(() => {
      if (!vivo || !alvo.current) return;
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: (resp) => resp?.credential && cb.current(resp.credential),
        ux_mode: "popup",
      });
      alvo.current.innerHTML = "";
      window.google.accounts.id.renderButton(alvo.current, {
        theme: "outline", size: "large", shape: "pill", text: texto, locale: "pt-BR",
        width: Math.min(alvo.current.offsetWidth || 320, 400),
      });
    }).catch(() => { /* sem o script do Google, fica só o e-mail e senha */ });
    return () => { vivo = false; };
  }, [clientId, texto]);

  if (!clientId) return null;
  return (
    <div className="mb-5">
      <div ref={alvo} className="flex w-full justify-center" />
      <div className="mt-4 flex items-center gap-3 text-xs text-gray-400">
        <span className="h-px flex-1 bg-gray-200" />ou com e-mail e senha<span className="h-px flex-1 bg-gray-200" />
      </div>
    </div>
  );
}
